export const manualInvoiceModal = {
  modalTitle: {
    create: "Rechnung manuell erstellen",
    correcting: "Rechnungsdaten korrigieren",
  },
  confirm: {
    title: "Vor dem Erstellen prüfen",
    subtitle:
      "Es wird ein Entwurf erstellt. Sie können ihn prüfen, Positionen hinzufügen und ihn jederzeit ausstellen.",
    rowDocument: "Dokument",
    documentValue: "Entwurf · Nummer bei Ausstellung",
    rowType: "Typ",
    typeCompany: "Firma / Juristische Person",
    typeIndividual: "Privatperson",
    labelCompanyName: "Firmenname",
    labelName: "Name",
    rowCountry: "Land",
    rowEmail: "E-Mail",
    rowAddress: "Adresse",
    rowPayment: "Zahlung",
    rowNotes: "Notizen",
  },
  info: {
    createTitle: "Es wird ein RECHNUNGSENTWURF erstellt (ohne Nummer bis zur Ausstellung).",
    correctingTitle: "Steuerdaten korrigieren",
    createBody:
      "Er wird als Entwurf gespeichert. Sie können Positionen hinzufügen und ihn ausstellen, sobald er fertig ist. Die fortlaufende Nummer vergibt die Steuerbehörde bei der Ausstellung.",
    correctingBody:
      "Ändern Sie nur die Daten, die korrigiert werden müssen. Es wird eine <strong>Korrekturrechnung</strong> mit den richtigen Daten erstellt.",
  },
  prefillLoading: "Steuerdaten des Gastes werden geladen…",
  // Facturar toda la reserva o una sola habitación (reservas de varias).
  scope: {
    lead: "Diese Buchung hat mehrere Zimmer. Welche Rechnung möchten Sie erstellen?",
    continue: "Weiter",
    label: "Wie möchten Sie abrechnen?",
    whole: "Die ganze Buchung",
    wholeHint: "Eine einzige Rechnung mit {n} Zimmern.",
    perRoom: "Ein Zimmer",
    perRoomHint: "Jedes Zimmer seine eigene Rechnung: seine Nächte und seine Posten.",
    pickRoom: "Zimmer auswählen",
    repeatHint: "Für jedes Zimmer wiederholen, damit jeder Gast seine eigene bekommt.",
  },

  recipientType: {
    label: "Empfängertyp",
    individual: "Privatperson",
    individualSub: "Natürliche Person",
    company: "Firma",
    companySub: "Juristische Person",
    active: "Aktiv",
  },
  // Buscador de clientes del fichero dentro del modal: evita teclear a mano
  // una empresa que ya está guardada.
  client: {
    label: "Gespeicherter Kunde",
    help: "Suche einen Kunden aus der Kundendatei – seine Steuerdaten werden automatisch eingetragen. Ist er nicht dabei, gib die Daten manuell ein.",
    clear: "Entfernen",
    linkedHint: "Daten aus der Kundenakte. Du kannst jedes Feld korrigieren, ohne die Verknüpfung zum Kunden zu verlieren.",
    noFiscalProfile: "Dieser Kunde hat kein gespeichertes Rechnungsprofil: Name und E-Mail haben wir übernommen, der Rest muss eingegeben werden (oder vervollständige seine Akte unter Kunden).",
  },
  fields: {
    nameCompany: "Firmenname *",
    nameIndividual: "Vollständiger Name *",
    country: "Land",
    countryPlaceholder: "Land des Gastes auswählen",
    countryHint: "Geben Sie das Steuerland des Gastes für die Rechnung an.",
    optional: "(optional)",
    emailLabel: "Rechnungs-E-Mail",
    phoneLabel: "Telefon",
    addressLabel: "Steueranschrift",
    sectionInvoiceData: "Rechnungsdaten",
    paymentSourceLabel: "Zahlungsquelle",
    paymentHintPrefilled:
      "Aus den von Ihnen erfassten Zahlungen übernommen. Ändern Sie es, falls es nicht stimmt.",
    paymentHintMulti:
      "Sie können mehrere auswählen, wenn der Aufenthalt auf mehreren Wegen bezahlt wurde.",
    paymentHintNone: "Wenn nichts ausgewählt ist, weist die Rechnung die Zahlungsart nicht aus.",
    seriesLabel: "Nummernkreis",
    seriesHint: "Dieser Nummernkreis stammt aus Ihren Rechnungseinstellungen.",
    notesLabel: "Zusätzliche Rechnungsangaben",
    notesHint:
      "Ergänzen Sie hier einen freien Text, Hinweise oder weitere Angaben zur Ausstellung.",
  },
  preview: {
    label: "Nächste fortlaufende Nummer",
    estHint: "als Orientierung · wird bei der Ausstellung vergeben (wer zuerst ausstellt, erhält sie)",
    noNumber: "Wird bei der Ausstellung vergeben · der Entwurf hat keine Nummer",
  },
  footer: {
    cancel: "Abbrechen",
    create: "Rechnung erstellen",
    editData: "Daten bearbeiten",
    creating: "Wird erstellt...",
    createDraft: "Entwurf erstellen",
  },
  success: {
    title: "Rechnung ausgestellt!",
    badge: "Ausgestellt",
    pdfGenerating: "Das PDF wird erstellt. Das kann einige Sekunden dauern.",
    downloadPdf: "Rechnung als PDF herunterladen",
    generatingPdf: "PDF wird erstellt…",
    sendWhatsapp: "Per WhatsApp senden",
    closeWindow: "Fenster schließen",
  },
  paymentSource: {
    cash: "Bargeld",
    card: "Kreditkarte",
    transfer: "Banküberweisung",
    otherOta: "Über eine andere OTA bezahlt",
  },
  prefill: {
    clientFile:
      "Daten aus der Kundenakte. Prüfe sie, bevor du den Entwurf erstellst.",
    invoiceRecipient: "Daten aus der letzten Rechnung des Gastes vorausgefüllt.",
    chat: "Steuerdaten, die der Gast bei der Rechnungsanfrage angegeben hat. Prüfen Sie sie und stellen Sie die Rechnung aus.",
    checkin:
      "Wir haben Name und E-Mail des Gastes aus seinem Check-in übernommen. Ergänzen Sie unten die Steuerdaten.",
    reservation:
      "Es lagen keine vollständigen Steuerdaten vor; als Grundlage dienen die Basisdaten der Buchung.",
    existingInvoice:
      "Daten aus der vorhandenen Rechnung vorausgefüllt. Ändern Sie, was korrigiert werden muss.",
  },
  status: {
    sent: "Ausgestellt",
    processing: "In Bearbeitung",
    pending: "Ausstehend",
    error: "Fehler",
  },
  toast: {
    whatsappSent: "Rechnung per WhatsApp gesendet.",
    whatsappError: "Die Rechnung konnte nicht per WhatsApp gesendet werden.",
    draftCreated: "Entwurf erstellt. Prüfen Sie ihn und stellen Sie ihn aus, wenn er fertig ist.",
  },
  validation: {
    nameRequired: "Name oder Firmenname ist erforderlich.",
    countryInvalid: "Wählen Sie ein gültiges Land.",
    emailInvalid: "Geben Sie eine gültige E-Mail ein.",
    taxIdRequired: "Diese Steuernummer ist für diesen Empfängertyp erforderlich.",
  },
  errors: {
    conflict: "Für diese Buchung wurde bereits eine Rechnung erstellt.",
    checkData: "Prüfen Sie die Rechnungsdaten.",
    createFailed: "Die Rechnung konnte nicht erstellt werden.",
  },
  taxId: {
    labels: {
      esCompany: "NIF der Firma",
      brIndividual: "CPF oder RG",
      defaultIndividual: "Steueridentifikationsnummer",
      defaultCompany: "Steuernummer",
    },
    hints: {
      esIndividual: "DNI oder NIE (X1234567A). Ein Reisepass ist keine gültige Steuernummer.",
      esCompany: "NIF/CIF der Firma.",
      ptIndividual: "9 Ziffern.",
      ptCompany: "9 Ziffern.",
      coIndividual: "6-10 Ziffern.",
      coCompany: "NIT mit Prüfziffer.",
      mxIndividual: "RFC für eine natürliche Person.",
      mxCompany: "RFC für eine juristische Person.",
      arIndividual: "11 Ziffern mit Prüfziffer.",
      arCompany: "11 Ziffern mit Prüfziffer.",
      clIndividual: "Mit Prüfziffer.",
      clCompany: "Mit Prüfziffer.",
      peIndividual: "8 Ziffern.",
      peCompany: "11 Ziffern.",
      ecIndividual: "10 Ziffern.",
      ecCompany: "13 Ziffern.",
      brIndividual:
        "Gültiger CPF für die steuerliche Rechnungsstellung. Wenn Sie einen RG eingeben, wird er als lokales Ausweisdokument des Gastes gespeichert.",
      brCompany: "14 Ziffern.",
      defaultIndividual: "Optional.",
      defaultCompany: "Für Firmen erforderlich.",
    },
  },
  address: {
    ES: { city: "Stadt", state: "Provinz", zip: "PLZ" },
    PT: { city: "Stadt", state: "Distrikt", zip: "PLZ" },
    CO: { city: "Stadt", state: "Dept.", zip: "PLZ" },
    MX: { city: "Stadt", state: "Bundesstaat", zip: "PLZ" },
    AR: { city: "Stadt", state: "Provinz", zip: "PLZ" },
    CL: { city: "Stadt", state: "Region", zip: "PLZ" },
    BR: { city: "Stadt", state: "Bundesstaat", zip: "CEP" },
    US: { city: "Stadt", state: "Bundesstaat", zip: "ZIP" },
    GB: { city: "Stadt", state: "Grafschaft", zip: "Postcode" },
    DEFAULT: { city: "Stadt", state: "Region", zip: "PLZ" },
  },
  taxErrors: {
    cifCompany: "Ungültige NIF/CIF der Firma.",
    esIndividual: "Ungültiges Dokument. Geben Sie einen DNI, NIE (X1234567A) oder Reisepass ein.",
    ptNif: "Ungültige NIF. Sie muss 9 gültige Ziffern haben.",
    nit: "Ungültige NIT.",
    coCedula: "Ungültige Cédula. Zwischen 6 und 10 Ziffern.",
    rfc: "Ungültige RFC.",
    cuit: "Ungültige CUIT.",
    cuilCuit: "Ungültige CUIL/CUIT.",
    rut: "Ungültige RUT.",
    ruc: "Ungültige RUC.",
    peDni: "Ungültiger DNI. Er muss 8 Ziffern haben.",
    ecCedula: "Ungültige Cédula.",
    cnpj: "Ungültige CNPJ.",
    brIndividual: "Ungültiges Dokument. Verwenden Sie einen gültigen CPF oder einen RG im üblichen Format.",
  },
};
